import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import * as exElement from '../../utils/element';

import * as exButton from './button';
import * as exDetail from './detail';
import * as exRows from './rows';
import * as exScroll from './scroll';
import * as exSelect from './select';
import { columns } from './columns';

import type { TypeTableConfig } from './types';

// ----------------------------------------------------------------------------

function create(config: TypeTableConfig = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        display: true,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {
        elements: {},
    };

    // Create element (table)
    const elTable = exElement.create({
        merge: defConfig,
        tag: 'table',
        class: {
            new: 'table',
        },
    });
    build.element = elTable;
    build.elements.element = elTable;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build;
}

function settings(build: Record<string, any>, config: TypeTableConfig = {}): void {
    const elements = build.elements;

    // ------------------------------------------------------------------------

    // If using display
    if (config.display === true) {
        addClass(elements.element, 'table-display');

        config.striped = config.striped !== false;
        config.bordered = config.bordered !== false;
        config.hover = config.hover !== false;
    }

    // If using striped
    if (config.striped === true) {
        addClass(elements.element, 'table-striped');
    }

    // If using bordered
    if (config.bordered === true) {
        addClass(elements.element, 'table-bordered');
    }

    // If using hover
    if (config.hover === true) {
        addClass(elements.element, 'table-hover');
    }

    // ------------------------------------------------------------------------

    // If using columns
    if (!isEmptyArray(config.columns)) {
        columns(elements.element, config);
    }

    // If using data
    if (Array.isArray(config.data) && config.data.length > 0) {
        exRows.data(elements.element, {
            ...config,
            data: config.data,
        });
    }

    // ------------------------------------------------------------------------

    // If using layout
    if (!isEmptyObject(config.layout)) {
        exRows.count(elements.element, config.layout);
    }

    // ------------------------------------------------------------------------

    // If using buttons
    if (!isEmptyObject(config.buttons)) {
        exButton.start(elements.element, config.buttons);
    }

    // ------------------------------------------------------------------------

    // If using select
    if (config.select === true || !isEmptyObject(config.select)) {
        exSelect.start(elements.element, config.select);
    }

    // If using detail
    if (config.detail === true || !isEmptyObject(config.detail)) {
        // If using basic detail
        if (config.detail.open === 'basic') {
            exDetail.create(elements.element, config.detail);
        }
        // If using modal detail
        else if (config.detail.open === 'modal') {
            exDetail.modal(elements.element, config.detail);
        }
    }

    // If using scroll
    if (config.scroll === true || !isEmptyObject(config.scroll)) {
        exScroll.start(elements.element, config.scroll);
    }
}

// ----------------------------------------------------------------------------

export { create };
